import React, { useContext } from 'react'
import { ControlledForm, CenteredCard, ErrorBanner, PromiseButton } from 'components'
import TextField from '@material-ui/core/TextField'
import FormGroup from '@material-ui/core/FormGroup';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography'
import { TokensContext } from 'contexts'
import {useFormData} from 'hooks'
import {useHistory} from 'react-router-dom'

const Reset = () => {
  const tokens = useContext(TokensContext.ReactContext)
  const history = useHistory()
  const [formData, setFormData] = useFormData()

  const token = window.location.search.replace(/^.*?token=([^$&]+)/,'$1')

  const submit = async () => {
    await tokens.actions.reset({...formData, token})
    await tokens.actions.verify()
    history.push('/')
  }

  const errors = tokens.errors.reset?.meta

  return (
    <CenteredCard>
      <ControlledForm data={formData} errors={errors} onChange={setFormData} onSubmit={submit}>
        <CardContent>
          <Typography variant='h6'>Reset your password</Typography>
          {tokens.errors.reset && <ErrorBanner>{tokens.errors.reset.title}</ErrorBanner>}
          <FormGroup>
            <TextField fullWidth name='password'             type='password' autoFocus/>
            <TextField fullWidth name='passwordConfirmation' type='password' label='Password'/>
          </FormGroup>
        </CardContent>
        <CardActions>
          <PromiseButton type='submit' variant='contained' color='secondary' fullWidth>Submit</PromiseButton>
        </CardActions>
      </ControlledForm>
    </CenteredCard>
  )
}

export default Reset
